import { DecimalPipe, registerLocaleData, APP_BASE_HREF } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import localeVi from '@angular/common/locales/vi';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from '@angular/service-worker';
import { LayoutModule } from '@common/layout/layout.module';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { CoreModule } from "./core/core.module";
import { AuthorizationGuard } from './core/guards/authorization.guard';
import { RoutesModule } from "./routes/routes.module";

registerLocaleData(localeVi, 'vi');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [    
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input,
    CoreModule,
    LayoutModule,
    RoutesModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      backdropBackgroundColour: 'rgba(128,128,128,0.4)',
      backdropBorderRadius: '4px',
      primaryColour: '#35aabe',
      secondaryColour: '#11dfaa',
      tertiaryColour: '#000000'
    }),
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'vi' },
    { provide: APP_BASE_HREF, useValue: '/' },

    AuthorizationGuard,
    DecimalPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
